// The throwaway pieces of the leftover strip's animation (leftover_fill_controller):
// the $ chip, the sparks and the glow where it lands, the shine across the goal
// strip. All of them are fixed to the viewport so the rail can scroll under
// them, and every one removes itself when its animation ends. Looks live in
// budgets/_dashboard_styles (.lf-*).

const SPARK_COLORS = ["#34D399", "#FCD34D", "#FFFFFF", "#10B981", "#FBBF24"]

export function fixedAt(className, x, y, html = "") {
  const el = document.createElement("div")
  el.className = `lf-fx ${className}`
  el.innerHTML = html
  el.style.left = `${x}px`
  el.style.top = `${y}px`
  document.body.appendChild(el)
  return el
}

// The amount, lifted off the strip's title as a pill over the same spot.
export function chipOver(amountEl) {
  const r = amountEl.getBoundingClientRect()
  const chip = fixedAt("lf-chip", 0, 0, amountEl.innerHTML)
  chip.style.left = `${r.left + r.width / 2 - chip.offsetWidth / 2}px`
  chip.style.top = `${r.top + r.height / 2 - chip.offsetHeight / 2}px`
  return chip
}

export function centreOf(el) {
  return { x: el.offsetLeft + el.offsetWidth / 2, y: el.offsetTop + el.offsetHeight / 2 }
}

export function sparks(x, y, count) {
  for (let i = 0; i < count; i++) {
    const angle = Math.PI * (1.05 + Math.random() * 0.9)
    const speed = 24 + Math.random() * 34
    const dx = Math.cos(angle) * speed
    const dy = Math.sin(angle) * speed
    const spark = fixedAt("lf-spark", x, y)
    spark.style.background = SPARK_COLORS[i % SPARK_COLORS.length]
    if (i % 3 === 0) spark.style.borderRadius = "50%"
    spark.animate([
      { transform: "translate(0, 0) rotate(0deg)", opacity: 1, easing: "cubic-bezier(0.2, 0.8, 0.4, 1)" },
      { transform: `translate(${dx}px, ${dy}px) rotate(${Math.random() * 300}deg)`, opacity: 1, offset: 0.55, easing: "cubic-bezier(0.5, 0, 0.9, 0.5)" },
      { transform: `translate(${dx * 1.25}px, ${dy + 34}px) rotate(${Math.random() * 500}deg) scale(0.4)`, opacity: 0 }
    ], { duration: 820 + Math.random() * 300, fill: "forwards" }).finished.then(() => spark.remove(), () => spark.remove())
  }
}

export function glow(x, y) {
  const el = fixedAt("lf-glow", x - 30, y - 30)
  el.animate([
    { opacity: 0, transform: "scale(0.4)" },
    { opacity: 1, transform: "scale(1.1)", offset: 0.25 },
    { opacity: 0, transform: "scale(1.6)" }
  ], { duration: 900, easing: "ease-out", fill: "forwards" }).finished.then(() => el.remove(), () => el.remove())
}

// One sweep of light across the goal strip once it has settled.
export function shine(strip) {
  const el = document.createElement("span")
  el.className = "lf-shine"
  el.setAttribute("aria-hidden", "true")
  el.innerHTML = "<i></i>"
  strip.appendChild(el)
  el.firstChild.animate([{ transform: "translateX(-120%)" }, { transform: "translateX(220%)" }],
                        { duration: 900, easing: "cubic-bezier(0.4, 0, 0.2, 1)", fill: "forwards" })
    .finished.then(() => el.remove(), () => el.remove())
}

// "+$495" rising over the goal strip's end, held, then gone.
export function deltaOver(strip, html, rtl) {
  const r = strip.getBoundingClientRect()
  const chip = fixedAt("lf-chip lf-delta", 0, r.top - 14, `+${html}`)
  chip.style.left = rtl ? `${r.left + 24}px` : `${r.right - 24 - chip.offsetWidth}px`
  chip.animate([
    { opacity: 0, transform: "translateY(10px) scale(0.7)" },
    { opacity: 1, transform: "translateY(-6px) scale(1.05)", offset: 0.18 },
    { opacity: 1, transform: "translateY(-8px) scale(1)", offset: 0.8 },
    { opacity: 0, transform: "translateY(-16px) scale(0.96)" }
  ], { duration: 2200, easing: "cubic-bezier(0.22, 1, 0.36, 1)", fill: "forwards" })
    .finished.then(() => chip.remove(), () => chip.remove())
}

// Never cached mid-flight: a snapshot taken during the animation would bring
// a hovering chip back on the next visit.
document.addEventListener("turbo:before-cache", () => {
  document.querySelectorAll(".lf-fx").forEach((el) => el.remove())
})
